module.exports = __webpack_public_path__ + "static/media/skeleton_head.de53675a.png";